<template>
  <div>
    <div v-if="applicationPrePage === 'none' && !recordVisible">
      <el-card shadow="never">
        <div class="assets_top_box">
          <div class="assets_top_left">
            <el-image :src="avatar" class="assets-avatar">
              <div slot="error">
                <img src="@/assets/img/avatar.png" class="assets-avatar" />
              </div>
            </el-image>
            <div style="margin-left: 30px">
              <div class="assets_name">您好，{{name}}</div>
              <div class="assets_subname">{{userInfo.phoneNumber}}</div>
              <div>
                若您对服务或实验不满意，可填写
                <el-button style="margin: 0 5px; text-decoration: underline;" type="text" @click="feedbackVisible = true">投诉 / 建议</el-button>
                为您安排解决！
              </div>
            </div>
          </div>
          <div class="assets_top_right">
            <div class="assets_right_name">客服一对一为您答疑解惑</div>
            <div class="assets_right_img">
              <el-image :src="serviceQRCode || defaultServiceQRCode" class="lxfs">
                <div slot="error">
                  <img class="lxfs" :src="defaultServiceQRCode" />
                </div>
              </el-image>
            </div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" style="margin: 20px 0">
        <div slot="header" class="clearfix">
          <div class="desciconLarge"></div>
          <span class="font18">账户信息</span>
        </div>
        <div class="assets-box">
          <div class="assets-item" v-loading="loading">
            <div class="assets-money">￥ {{ (moneyInfo.depositAdvance + moneyInfo.cashCouponBalance).toFixed(2) || '0.00' }} </div>
            <div class="assets-label">
              <span>账户余额</span>
              <el-tooltip class="item" effect="dark" :content="`账户余额为：预存余额￥${ moneyInfo.depositAdvance } + 赠送金￥${ moneyInfo.cashCouponBalance }（赠送金只能支付订单和补差价，不参与还款、活动等其他福利）`" placement="bottom">
                <i class="el-icon-warning"></i>
              </el-tooltip>
              <el-button type="success" size="small"  @click="applyPrestore('applicationPre')">申请预存</el-button>
              <el-button type="primary" size="small"  @click="prestoreRecord">个人预存记录</el-button>
            </div>
          </div>
          <div class="assets-item" v-loading="loading">
            <div class="assets-money">￥ {{ moneyInfo.ownDebt || '0.00' }} </div>
            <div class="assets-label">
              <span>待入帐</span>
              <el-tooltip class="item" effect="dark" content="已开发票但未入账金额" placement="bottom">
                <i class="el-icon-warning"></i>
              </el-tooltip>
              <el-button type="primary" size="small" @click="toMyInvoice">上传凭证</el-button>
            </div>
          </div>
          <div class="assets-item" v-loading="loading">
            <div class="assets-money">￥ {{ moneyInfo.clientCreditBalance || '0.00' }} </div>
            <div class="assets-label">
              <span>信用余额</span>
              <el-tooltip class="item" effect="dark" :content="`信用余额为：授信总额￥${ moneyInfo.lineCredit } - 个人信用欠款￥${ moneyInfo.toBePaidDebt }`" placement="bottom">
                <i class="el-icon-warning"></i>
              </el-tooltip>
              <el-button type="primary" size="small" @click="toRepay">立即还款</el-button>
            </div>
          </div>
          <div class="assets-item" v-loading="loading">
            <div class="assets-money">￥ {{ moneyInfo.demandInvoiceMoney || '0.00' }} </div>
            <div class="assets-label">
              <span>待开发票</span>
              <el-button type="primary" size="small" @click="toApplyInvoice">去开票</el-button>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 订单列表 -->
      <myGoods></myGoods>
    </div>
    <div>
      <!-- 常规预存申请 -->
      <applicationPre v-if="applicationPrePage === 'applicationPre'" ref="applicationPre" @goBack="applicationPrePage = 'none'" @backAndRefresh="backAndRefresh"></applicationPre>
      <!-- 耗材商城预存申请 -->
      <reagentMallApplicationPre v-if="applicationPrePage === 'reagentMallApplicationPre'" ref="reagentMallApplicationPre" @goBack="applicationPrePage = 'none'" @backAndRefresh="backAndRefresh"></reagentMallApplicationPre>
      <!-- 个人预存记录 -->
      <personPrestoreRecord v-if="recordVisible" ref="record" @back="closeInvoice"></personPrestoreRecord>
    </div>

    <!-- 投诉/建议 弹框 -->
     <el-dialog title="投诉 / 建议" :visible.sync="feedbackVisible" width="30%" center @closed="closeFeedbackDialog">
      <div class="feedback-dialog">
        <el-input placeholder="可填写匿名昵称，如：小明" v-model="submitFeedbackData.clientName">
          <template slot="prepend">
            <div class="feedback-label title"><span style="color: #FF4A2B;">*</span>反馈人：</div>
          </template>
        </el-input>
        <el-input placeholder="请填写联系电话" v-model="submitFeedbackData.phoneNumber">
          <template slot="prepend">
            <div class="feedback-label title"><span style="color: #FF4A2B;">*</span>联系电话</div>
          </template>
        </el-input>
        <div>
          <div class="title"><span style="color: #FF4A2B;">*</span>反馈类型</div>
          <div class="feedback-type-list">
            <div class="feedback-type" :class="{'feedback-type-active': feedbackTypeValue.includes(item.value)}" v-for="(item, index) in feedbackTypeList" :key="index" @click="selectFeedbackType(item.value)">{{ item.label }}</div>
          </div>
        </div>
        <div>
          <div class="title">反馈描述</div>
          <el-input style="margin-top: 15px;" :maxlength="200" :show-word-limit="true" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入内容" v-model="submitFeedbackData.feedbackDesc"></el-input>
        </div>
        <el-upload
          ref="uploadStatic"
          show-file-list
          action=""
          :file-list="fileList"
          :limit="1"
          :on-success="handleUploadSuccess"
          :before-upload="handleBeforeUpload"
          :on-error="handleUploadError"
          :on-exceed="handleExceed"
          :on-remove="handleDelete"
          :http-request="qiniuUpload"
        >
          <el-button type="primary">上传附件 <i class="el-icon-upload el-icon--right"></i></el-button>
        </el-upload>
      </div>
      <span slot="footer" class="feedback-footer">
        <el-button :loading="submitLoading" @click="feedbackVisible = false">取 消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitFeedback">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as qiniu from 'qiniu-js'
import myGoods from "./myGoods"
import applicationPre from "./formPop/applicationPre.vue";
import reagentMallApplicationPre from "./formPop/reagentMallApplicationPre.vue";
import personPrestoreRecord from "./personPrestoreRecord"
import { mapGetters } from "vuex";
import { myAssetsMoney, getActivityUploadGetToken, useSubmitFeedback } from "@/api/request"
import { getClient } from "@/plugins/auth";

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      applicationPrePage: 'none',
      recordVisible: false,
      feedbackVisible: false,
      userInfo: JSON.parse(getClient()),
      serviceQRCode: localStorage.getItem('serviceQRCode'),
      defaultServiceQRCode: require("@/assets/img/lxfs.png"),
      moneyInfo: {},
      feedbackTypeList: [
        { label: '功能异常', value: '功能异常' },
        { label: '操作不便', value: '操作不便' },
        { label: '服务态度', value: '服务态度' },
        { label: '数据质量', value: '数据质量' },
        { label: '开票报账', value: '开票报账' },
        { label: '售后处理', value: '售后处理' },
        { label: '样品相关', value: '样品相关' },
        { label: '其他', value: '其他' },
      ],
      feedbackTypeValue: [],
      qiniuBaseFilePath: 'https://pstatic.navi-sci.cn/',
      submitFeedbackData: {
        clientId: JSON.parse(getClient()).clientId,//客户id
        clientName: JSON.parse(getClient()).clientName,//反馈人
        phoneNumber: JSON.parse(getClient()).phoneNumber,//客户电话
        feedbackType: '',//反馈类型
        feedbackDesc: '',//反馈描述"
        attachment: '',//附件
      },
      subscription: null,
      tokenData: {
          key: '',
          token: '',
          putExtra: {
              fname: ''
          },
          config: {
              chunkSize: 10,
              region: 'qiniu.region.z2'
          }
      },
      fileList: [],//需上传文件列表
    };
  },
  components: {
      myGoods,
      personPrestoreRecord,
      applicationPre,
      reagentMallApplicationPre,
  },
  computed: {
    ...mapGetters(["avatar", "name"])
  },
  watch: {
    '$route': {
      handler(route) {
        if (route.query.applicationPrePage) {
          this.applyPrestore(route.query.applicationPrePage)
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.refreshServiceQRCode()
    this.getFileToken()
    this.getMoney()
  },
  methods: {
    async refreshServiceQRCode() {
      try {
        await this.$store.dispatch('setKefuQRCode')
        this.serviceQRCode = localStorage.getItem('serviceQRCode')
      } catch (error) {
        this.serviceQRCode = localStorage.getItem('serviceQRCode')
      }
    },
    getFileToken() {
      getActivityUploadGetToken().then((res) => {
          this.tokenData.key = res.data.key;
          this.tokenData.token = res.data.token;
          this.$forceUpdate()
      });
    },
    getMoney () {
      this.loading = true
      myAssetsMoney(this.userInfo.clientId).then(res=> {
        this.moneyInfo = res.data
        this.loading = false
      })
    },
    //申请预存
    applyPrestore (value = 'applicationPre') {
      this.applicationPrePage = value
    },
    //返回并刷新页面
    backAndRefresh() {
        this.applicationPrePage = 'none'
        this.getMoney()
    },
    //个人预存记录
    prestoreRecord () {
      this.recordVisible = true;
    },
    closeInvoice () {
      this.recordVisible = false
      this.getMoney()
    },
    //前往【我的发票】
    toMyInvoice() {
      this.$emit('gotoPage', '3-2')
    },
    //前往【立即还款】---个人
    toRepay() {
      this.$emit('gotoPage', '2-4', 'userOrderOperate', 0)
    },
    //去开票
    toApplyInvoice() {
      this.$emit('gotoPage', '2-4', 'userOrderOperate', 1)
    },
    //选择【投诉/建议】类型
    selectFeedbackType(value) {
      const index = this.feedbackTypeValue.findIndex(item => item == value)
      if(index >= 0) {
        this.feedbackTypeValue.splice(index, 1)
      } else {
        this.feedbackTypeValue.push(value)
      }
      this.submitFeedbackData.feedbackType = this.feedbackTypeValue.join(',')
    },
    // 上传前加载
    handleBeforeUpload (file) {
      this.tokenData.putExtra.fname = file.name;
    },
    // 文件个数超出
    handleExceed () {
      this.$message.warning(`只能上传一个文件!`)
    },
    // 删除文件
    handleDelete (file) {
      this.fileList = this.fileList.filter(item => item.uid != file.uid)
      this.submitFeedbackData.attachment = undefined
    },
    //自定义上传图片处理函数
    qiniuUpload(options) {
      // qiniu.rs
      let file = options.file
      const observable = qiniu.upload(
        file,
        this.tokenData.key,
        this.tokenData.token,
        '{}',
        {
          region: 'qiniu.region.z2',
          uphost: [], //不知道能传什么host，留空 使用默认
          chunkSize: 20 // 分片大小 10M
        }
      )
      // 开始上传
      this.subscription = observable.subscribe({
        next: () => {
        },
        error: (err) => {
          this.$message.error(err.message);
        },
        complete: (res) => {
          let fileListItem = {
              name: file.name,
              url: this.qiniuBaseFilePath + res.key,
          }
          this.fileList.push(fileListItem)
          this.submitFeedbackData.attachment = this.qiniuBaseFilePath + res.key
          this.subscription = null
          this.getFileToken()
        }
      })
    },
    // 上传失败
    handleUploadError () {
      this.$message.error("上传文件失败，请重试")
    },
    // 上传成功回调
    handleUploadSuccess (res, fileList) {
      this.$message.success('上传成功');
    },
    //关闭【建议/投诉】弹框
    closeFeedbackDialog() {
      this.submitFeedbackData = {
        clientId: this.userInfo.clientId,//客户id
        clientName: '',//反馈人
        phoneNumber: this.userInfo.phoneNumber,//客户电话
        feedbackType: '',//反馈类型
        feedbackDesc: '',//反馈描述"
        attachment: '',//附件
      }
      this.feedbackTypeValue = []
      this.fileList = []
    },
    //提交【建议/投诉】
    async submitFeedback() {
      if(!this.submitFeedbackData.clientName) {
        this.$message.warning('请填写反馈人！')
        return
      }
      if(!this.submitFeedbackData.phoneNumber) {
        this.$message.warning('请填写联系电话！')
        return
      }
      if(!this.submitFeedbackData.feedbackType) {
        this.$message.warning('请选择反馈类型！')
        return
      }
      this.submitLoading = true
      try {
        await useSubmitFeedback(this.submitFeedbackData)
        this.$message.success('提交成功！')
        this.submitLoading = false
        this.feedbackVisible = false
      }
      catch {
        this.submitLoading = false
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.assets_top_box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.assets_top_left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.assets_name {
  font-size: 22px;
  font-weight: 600;
  color: #333333;
}
.assets_subname {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}
.assets-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.assets_right_name {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
}
.assets_right_img {
  width: 100px;
  height: 100px;
  margin-top: 5px;
}
.lxfs {
  width: 100%;
}
.assets_top_right {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.assets-box {
  display: flex;
  column-gap: 20px;
  justify-content: space-between;
  .assets-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    justify-content: center;
    align-items: center;
    height: 100px;
    border-radius: 5px;
    border: 1px solid #ddd;
    .assets-money {
      font-size: 20px;
      font-weight: 600;
      color: #5CC300;
    }
    .assets-label {
      display: flex;
      column-gap: 10px;
      justify-content: space-around;
      align-items: center;
      font-size: 18px;
    }
    .el-icon-warning {
      cursor: pointer;
    }
  }
  .assets-item:hover {
    background-color: #84B7F930;
  }
}
.feedback-dialog {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  .feedback-label {
    width: 100px;
    text-align: center;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  .feedback-type-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 10px 20px;
    .feedback-type {
      cursor: default;
      padding: 10px 15px;
      border-radius: 5px;
      border: 1px solid #E8E8E8;
    }
    .feedback-type:hover {
      background-color: #51a0e910;
    }
    .feedback-type-active {
      color: #5D5D5D;
      border: 1px solid #51a0e9;
      background-color: #51a0e930;
    }
  }
}
.feedback-footer {
  display: flex;
  justify-content: space-between;
  width: 60%;
  margin: 0 auto;
  .el-button {
    width: 150px;
  }
}
</style>
